import { render } from "./TestLocation.vue?vue&type=template&id=0c5a1719&scoped=true"
import script from "./TestLocation.vue?vue&type=script&lang=js"
export * from "./TestLocation.vue?vue&type=script&lang=js"

import "./TestLocation.vue?vue&type=style&index=0&id=0c5a1719&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5a1719"]])

export default __exports__